import React from "react";
import { Toaster } from "react-hot-toast";
import "./toast.css";

const Toast = () => {
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        className: "toast-betre",
        success: { className: "toast-betre toast-betre--success" },
        error: { className: "toast-betre toast-betre--error" },
      }}
    />
  );
};

export default Toast;
